import React from 'react';
import {Badge} from 'reactstrap';
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";

let alertStrings = new LocalizedStrings(alert_strings);

const ProBadge = (props) => {

    const localize = () => {
        alertStrings.setLanguage(localeHelpers.currentLocale());
    };

    localize();

    return (
        <span style={{marginLeft: 4}}>
        <Badge
            color={props.color ? props.color : "default"}
            data-type="warning"
            data-tip={alertStrings.pro_functionality}>
            PRO
        </Badge>
            </span>
    );
};

export default ProBadge;